<template>
  <v-container class="mt-16">
    <div class="">
      <div>
        <v-card flat>
          <v-card-title class="d-flex">
            <h2>Chart of Accounts</h2>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mr-2" @click="printChartOfAccounts">
              <v-icon class="mr-2">mdi-printer</v-icon>
              Print
            </v-btn>
            <add-chart-of-account-modal />
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="search" label="Search"></v-text-field>
            <v-data-table
              :headers="headers"
              :items="chart_of_accounts"
              :search="search"
              :options="{ itemsPerPage: 30, sortBy: ['notes_to_fs'] }"
            >
              <template slot="item.actions" slot-scope="{ item }">
                <div class="d-flex">
                  <edit-chart-of-account-modal :item="item" />
                  <v-btn
                    color="red"
                    icon
                    small
                    @click="confirmDelete(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addChartOfAccountModal from "../components/ChartOfAccounts/addChartOfAccountModal.vue";
import EditChartOfAccountModal from "../components/ChartOfAccounts/editChartOfAccountModal.vue";
export default {
  components: { addChartOfAccountModal, EditChartOfAccountModal },
  data() {
    return {
      search: "",
      headers: [
        { text: "", value: "actions" },
        { text: "ID", value: "id" },

        { text: "Account Title", value: "account_title" },
        { text: "Notes to FS", value: "notes_to_fs" },
        { text: "Sub-Type", value: "sub_type" },
        { text: "Normal Balance", value: "normal_balance" },
        { text: "Remarks", value: "remarks" },
        { text: "Date Created", value: "created_at" },
      ],
    };
  },
  created() {
    this.get_chart_of_accounts();
  },
  methods: {
    ...mapActions({
      get_chart_of_accounts: "chart_of_account/get_chart_of_accounts",
      delete_chart_of_account: "chart_of_account/delete_chart_of_account",
    }),
    printChartOfAccounts() {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Chart of Accounts</title>
            <style>
              body { font-family: Arial, sans-serif; }
              table { width: 100%; border-collapse: collapse; }
              th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h1>Chart of Accounts</h1>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Account Title</th>
                  <th>Notes to FS</th>
                  <th>Normal Balance</th>
                  <th>Remarks</th>
                  <th>Date Created</th>
                </tr>
              </thead>
              <tbody>
                ${this.chart_of_accounts
                  .sort((a, b) => a.notes_to_fs.localeCompare(b.notes_to_fs))
                  .map(
                    (item) => `
                    <tr>
                      <td>${item.id}</td>
                      <td>${item.account_title}</td>
                      <td>${item.notes_to_fs}</td>
                      <td>${item.normal_balance}</td>
                      <td>${item.remarks}</td>
                      <td>${new Date(item.created_at).toLocaleDateString()}</td>
                    </tr>`
                  )
                  .join("")}
              </tbody>
            </table>
          </body>
        </html>`);
      printWindow.document.close();
      printWindow.print();
    },
    confirmDelete(item) {
      if (confirm(`Are you sure you want to delete "${item.account_title}"?`)) {
        this.deleteAccount(item);
      }
    },
    async deleteAccount(item) {
      try {
        await this.delete_chart_of_account(item);
        this.$toast.success("Chart of Account deleted successfully");
      } catch (error) {
        this.$toast.error("Error deleting Chart of Account");
        console.error("Delete error:", error);
      }
    },
  },
  computed: {
    ...mapGetters({
      chart_of_accounts: "chart_of_account/chart_of_accounts",
    }),
  },
};
</script>
